import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { SourceCodeExcludesService } from '../../../../services/source-code-excludes.service';

@Component({
    selector: 'form-source-code-exclude-steps-module',
    template: `
        <div class="mx-3 mt-6">
            <p translate>Please select the module that you want to create a Source Code Exclude for</p>
            <div class="row mt-3">
                <div class="col-12" *ngFor="let module of modules">
                    <button class="btn btn-border-radius btn-secondary flat max-width py-10"
                            type="button"
                            (click)="selectModule.emit({module: module.value})">
                        {{module.name}}
                    </button>
                </div>
            </div>
        </div>
    `,
    standalone: false,
})
export class FormSourceCodeExcludeStepsModuleComponent implements OnInit {
    modules: any[] = [];
    @Output() selectModule = new EventEmitter<any>();

    constructor (private sourceCodeExcludesService: SourceCodeExcludesService) {}

    ngOnInit (): void {
        this.modules = this.sourceCodeExcludesService.getTabs();
    }
}
